import { AxiosInstance } from 'axios'

export type LmeMedicine = {
  cid: number | null
  medicine: string
  month1: number
  month2: number
  month3: number
  month4: number
  month5: number
  month6: number
}

export type LmeData = {
  cidId: number
  medicines: LmeMedicine[]
  previousTreatments: string
  responsibleName: string
  cnes?: string
  anamnesis: string
  incapacity: boolean
  physicianName: string | undefined
  physicianCns: string | undefined
  printCurrentDate: boolean
  currentDate: string
  patientName: string
  patientMotherName: string | null
  patientWeight: string | null
  patientHeight: string | null
  patientSkinColor: string | null
  patientPhone: string | null
  patientCpf: string | null
  patientEmail: string | null
  patientBirthday: string | null
  patientAssignedSex: string | null
  patientId: number
  isGuidedAttendance?: boolean
}

export interface Dto {
  lme: LmeData
  documentId?: number
}

export function lmeEndpoints(apiClient: AxiosInstance) {
  return {
    async printGuidedAttendanceLme(dto: Dto): Promise<Blob> {
      return apiClient.post(`print-guided-attendance-lme`, dto, {
        responseType: 'blob',
      })
    },
  }
}
